// src/pages/SettingsPage/constants/settings.constants.ts
import {
  WorkspaceFormData,
  WorkspaceUserFormData,
} from "./types/settings.types";

export const initialWorkspaceUserFormData: WorkspaceUserFormData = {
  email: "",
  name: "",
};

export const initialWorkspaceFormData: WorkspaceFormData = {
  ownerEmail: "",
  ownerName: "",
  appName: "",
};
